import { render } from "./AppImage.vue?vue&type=template&id=81735740"
import script from "./AppImage.vue?vue&type=script&lang=js"
export * from "./AppImage.vue?vue&type=script&lang=js"

import "./AppImage.vue?vue&type=style&index=0&id=81735740&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__